export function leaderboardLeague(tier: number | string | undefined) {
  if (typeof tier === 'string') {
    tier = parseInt(tier);
  }
  switch (tier) {
    case 5:
      return 'Master';
    case 4:
      return 'Diamond';
    case 3:
      return 'Platinum';
    case 2:
      return 'Gold';
    case 1:
      return 'Silver';
    default:
      return 'Bronze';
  }
}

export function leaderboardTierBoundary(tier: number | string | undefined) {
  if (typeof tier === 'string') {
    tier = parseInt(tier);
  }
  switch (tier) {
    case 5:
      return 'above 2500';
    case 4:
      return 2500;
    case 3:
      return 1000;
    case 2:
      return 500;
    case 1:
      return 200;
    default:
      return 40;
  }
}
